import { Nullable } from '@types'

import searchApi from '@modules/search/api'
import { Company } from '@modules/search/types'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { ASSETS_OVERVIEW_ORDERED_TABS } from '../constants'

const useNumberOfLatestAssets = (companyId: Nullable<Company['id']>) => {
  const { key: apiKey, fn: apiFn } = searchApi.getLatestCompanyAssetProfiles

  const { data: { total } = {}, isLoading } = useQuery({
    queryKey: [apiKey, companyId],
    queryFn: () =>
      apiFn({
        companyId: companyId as number,
        from: 0,
        size: 0,
        types: ASSETS_OVERVIEW_ORDERED_TABS.map(type => ({ type })),
      }),
    enabled: !!companyId,
    placeholderData: keepPreviousData,
  })

  return {
    latestAssetsTotal: total,
    isLoading,
  }
}

export default useNumberOfLatestAssets
